<template>
    <div>
        <AppNavbar>
            <a href="/">
                <img
                    :src="logoUri"
                    height="38"
                    alt="logo">
            </a>
        </AppNavbar>
        <b-container fluid>
            <b-row>
                <div :class="['page-loader', { loading }]">
                    <b-spinner
                        style="width: 5rem; height: 5rem"
                        variant="primary" />
                </div>
                <template v-if="!loading">
                    <AppSidebar />
                    <AppContent :course-id="courseId" />
                </template>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import AppNavbar from "@/core/template/AppNavbar";
import AppSidebar from "@/core/template/AppSidebar";
import AppContent from "@/core/template/AppContent";

const SESSION_TOKEN_KEY = "session_token";

export default {
  name: "App",
  components: {
    AppNavbar,
    AppSidebar,
    AppContent,
  },
  props: {
    courseId: {
      type: [
        Number, String,
      ],
      default: 182,
    },
    logoUri: {
      type: String,
      required: true,
    },
    sessionToken: {
      type: String,
      default: "",
    },
  },
  data: () => ({ loading: false }),
  mounted() {
    if (this.sessionToken) {
      localStorage.setItem(SESSION_TOKEN_KEY, this.sessionToken);
    }
    this.loadCourse();
  },
  methods: {
    ...mapActions([
      "initializeCourse",
    ]),
    async loadCourse() {
      try {
        this.loading = true;
        await this.initializeCourse(this.courseId);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.page-loader {
  position: absolute;
  background: $white;
  transition: all 600ms ease;
  display: flex;
  align-items: center;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  margin: auto;
  justify-content: center;
  z-index: -1;
  visibility: hidden;
  opacity: 0;

  &.loading {
    z-index: 10;
    visibility: visible;
    opacity: 1;
  }
}
</style>
